module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-3-9dc8c2ec28de7d483fe7cba489041b1b.jpg";